import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { MARIGOLD_LIGHT, OLAF, SORBET_LIGHT, THUNDERDOME_LIGHT } from 'HubStyleTokens/colors';
import styled from 'styled-components';
import { devices } from '../styles/viewports.styles';
export let WaveType;

(function (WaveType) {
  WaveType["Error"] = "ErrorWave";
  WaveType["LowerStep"] = "LowerStepWave";
  WaveType["PostAccountCreation"] = "PostAccountCreationWave";
  WaveType["Step"] = "StepWave";
})(WaveType || (WaveType = {}));

const StyledWave = styled.div.withConfig({
  displayName: "Wave__StyledWave",
  componentId: "v48xp6-0"
})([".Wave{display:none;}@media ", "{.Wave{display:block;position:fixed;bottom:0;left:0;width:100%;max-height:35%;z-index:-1;isolation:isolate;}.Wave__Wrapper{svg{display:initial;}}path{transition:all 20s ease;}.StepWave{height:55%;max-height:70%;background:", ";}.LowerStepWave{height:20%;max-height:20%;background:", ";}.ErrorWave{background:", ";}.PostAccountCreationWave{background:", ";max-height:23%;}}"], devices.desktop, MARIGOLD_LIGHT, MARIGOLD_LIGHT, THUNDERDOME_LIGHT, SORBET_LIGHT);
export const Wave = ({
  type
}) => {
  return /*#__PURE__*/_jsx(StyledWave, {
    children: /*#__PURE__*/_jsx("div", {
      className: `Wave ${type}`,
      children: /*#__PURE__*/_jsx("div", {
        className: "Wave__Wrapper",
        children: /*#__PURE__*/_jsxs("svg", {
          viewBox: "0 0 1990 500",
          xmlns: "http://www.w3.org/2000/svg",
          children: [/*#__PURE__*/_jsx("path", {
            d: "M 0 0 C 382 0 573 182 955 182 L 955 182 L 955 0 L 0 0 Z",
            fill: OLAF,
            strokeWidth: "0"
          }), /*#__PURE__*/_jsx("path", {
            d: "M 954 182 C 1368.4 182 1575.6 83 1990 83 L 1990 83 L 1990 0 L 954 0 Z",
            fill: OLAF,
            strokeWidth: "0"
          })]
        })
      })
    })
  });
};